// export const isProd = false;

// export const apiBaseUrl = isProd ? 'http://43.217.35.18:9503/api/v1' : 'http://bab.local:9501/api/v1';
// http://bab.local:9506/api/v1

export enum ProductModelType {
    DEV = 'DEV',//本地
    SANDBOX = 'SANDBOX',//沙盒
    PROD = 'PROD',//生产
}

const parseProductModel = (value?: string): ProductModelType => {
    if (value === ProductModelType.DEV || value === ProductModelType.SANDBOX || value === ProductModelType.PROD) {
        return value;
    }
    return ProductModelType.PROD;
};

export let productModel = parseProductModel(window.__RUNTIME_CONFIG__?.productModel);

export const setProductModel = (type: ProductModelType) => {
    productModel = type;
}
export const getApiBaseUrl = () => {
    // 开发环境通过 CRA 本地服务做同源代理，避免浏览器直接请求不同域名时产生跨域问题。
    // 路径中的环境前缀会在 setupProxy.js 转发请求时被移除。
    const isOpenProxy = false;
    if (process.env.NODE_ENV === 'development' && isOpenProxy) {
        switch (productModel) {
            case ProductModelType.DEV:
                return '/api-proxy/dev/api/v1';
            case ProductModelType.SANDBOX:
                return '/api-proxy/sandbox/api/v1';
            case ProductModelType.PROD:
                return '/api-proxy/prod/api/v1';
        }
    }
    switch (productModel) {
        case ProductModelType.DEV:
            return 'http://bab.local:9501/api/v1';
        case ProductModelType.SANDBOX:
            return 'http://47.121.30.214:9503/api/v1';
        case ProductModelType.PROD:
            return 'https://chatbbg-api.bbgplus.vip/api/v1';
    }
}


export const getRsaPublicKey = () => {
    return productModel
}